module.exports = "<mat-divider></mat-divider>\n"